export const DAY_THRESHOLD = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
export const TWO_MIN_THRESHOLD = 2 * 60 * 1000; // 2 minutes in milliseconds
export const THIRTY_MIN_THRESHOLD = 30 * 60 * 1000; // 30 minutes in milliseconds